import React from 'react';
import { FaEdit } from 'react-icons/fa';

const statusOptions = ['Active', 'Inactive', 'Pending', 'Suspended'];
const CustomerTable = ({ customers, getCustomerCalls, onEdit, startIndex}) => (
  <div className="w-full">
    <div className="bg-white rounded-xl shadow-lg ">
      <table className="min-w-full shadow-md border">
        <thead className="bg-blue-400 text-white">
          <tr>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">ID</th>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">Client Name</th>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">Mobile Number</th>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">Email</th>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">Location</th>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">Description</th>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">Client Calls</th>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">staus</th>
            <th className="px-4 py-4 text-left text-sm uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {customers.map((customer, index) => (
            <tr
              key={customer._id}
              className={`transition-all duration-300 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-indigo-50`}
            >
              <td className="px-3 py-4 whitespace-nowrap text-sm  text-black">{startIndex + index + 1}</td>
              <td className="px-3 py-4 whitespace-nowrap text-sm  text-black">{customer.name}</td>
              <td className="px-3 py-4 whitespace-nowrap text-sm  text-black">{customer.mobileNumber}</td>
              <td className="px-3 py-4 whitespace-nowrap text-sm  text-black">{customer.email}</td>
              <td className="px-3 py-4 whitespace-nowrap text-sm  text-black">{customer.location}</td>
              <td className="px-3 py-4 text-sm  text-black">{customer.description || 'N/A'}</td>
              <td className="px-3 py-4 whitespace-nowrap text-sm  text-black">{getCustomerCalls(customer._id)}</td>
              <td className="px-3 py-4 whitespace-nowrap text-sm text-black">
                  {/* Static status - using first option as example */}
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    {statusOptions[0]}
                  </span>
                </td>
              
              <td className="px-6 py-4 whitespace-nowrap text-sm  text-black">
                
                  <button onClick={() => onEdit(customer)} type="button" class="text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700">edit</button>
                  {/* <FaEdit size={20} /> */}

                  <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">upgrade</button>
          
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default CustomerTable;